import React, { useEffect, useState } from 'react';
import {
    Color,
    IconButtonActionsPlacement,
    IconButtonList,
    Size,
    TextContentIcon,
    Variant,
} from '@signaturit/react-components-library';
import { IAction } from '@signaturit/react-components-library/src/lib/components/IconButtonList/ActionList/ActionList';
import { useDispatch, useSelector } from 'react-redux';
import { selectLanguageCode } from '../../../store/User/reducer';
import { getLangLabel } from './langSelectorHelper';
import { DashboardLang } from '../../../../constants/DashboardLang';
import { LANG_REGEX } from '../../../../helpers/LangHelper';
import { changeLanguage } from '../../../store/UserSettings/actions/changeLanguage';
import { selectChangedLanguageError, selectChangedLanguageSuccess } from '../../../store/UserSettings/reducer';

export const LangSelector = () => {
    const dispatch = useDispatch();
    const defaultLanguageCode = useSelector(selectLanguageCode);
    const changedLanguageSuccess = useSelector(selectChangedLanguageSuccess);
    const changedLanguageError = useSelector(selectChangedLanguageError);
    const [textContent, setTextContent] = useState<string>(getLangLabel(defaultLanguageCode));
    const [selectedLanguageCode, setSelectedLanguageCode] = useState<DashboardLang>(defaultLanguageCode);
    const [menuExpanded, setMenuExpanded] = useState(false);

    const englishLabel = getLangLabel(DashboardLang.English);
    const spanishLabel = getLangLabel(DashboardLang.Spanish);
    const frenchLabel = getLangLabel(DashboardLang.French);
    const germanLabel = getLangLabel(DashboardLang.German);
    const italianLabel = getLangLabel(DashboardLang.Italian);
    const portugueseLabel = getLangLabel(DashboardLang.Portuguese);

    const changeUrlLanguage = () => {
        location.pathname = location.pathname.replace(LANG_REGEX, `/${selectedLanguageCode}/`);
    };

    const onSelectOption = (languageCode: DashboardLang) => {
        setTextContent(getLangLabel(languageCode));
        setSelectedLanguageCode(languageCode);
        dispatch(changeLanguage(languageCode));
    };
    useEffect(() => {
        setTextContent(getLangLabel(defaultLanguageCode));
        setSelectedLanguageCode(defaultLanguageCode);
    }, [defaultLanguageCode]);

    useEffect(() => {
        const needsChangeUrlLanguage = changedLanguageSuccess || changedLanguageError;
        if (needsChangeUrlLanguage) {
            changeUrlLanguage();
        }
    }, [changedLanguageSuccess, changedLanguageError]);

    const langOptions: IAction[] = [
        { label: englishLabel, onClick: () => onSelectOption(DashboardLang.English) },
        { label: spanishLabel, onClick: () => onSelectOption(DashboardLang.Spanish) },
        { label: frenchLabel, onClick: () => onSelectOption(DashboardLang.French) },
        { label: germanLabel, onClick: () => onSelectOption(DashboardLang.German) },
        { label: italianLabel, onClick: () => onSelectOption(DashboardLang.Italian) },
        { label: portugueseLabel, onClick: () => onSelectOption(DashboardLang.Portuguese) },
    ];
    const onCollapseHandler = (actionsListExpanded: boolean) => {
        setMenuExpanded(actionsListExpanded);
    };

    return (
        <IconButtonList
            name="language-selector"
            actionsId="country"
            actions={langOptions}
            actionsPlacement={IconButtonActionsPlacement.BOTTOM_END}
            iconSize={Size.fullWidth}
            variant={Variant.text}
            color={Color.secondary}
            collapseHandler={onCollapseHandler}
            icon={<TextContentIcon content={textContent} menuExpanded={menuExpanded} name={'text-icon'} />}
        />
    );
};
